<template>
	<div class="form-group" :class="{ 'form-group--error' : validate.$error}">
		<fieldset class="fieldset" :aria-describedby="hintId" role="group">
			<legend class="fieldset__legend fieldset__legend--xl">    
				<h1>What is your date of birth?</h1>    
			</legend>
			<span :id="hintId" class="hint">For example. 31 - 05 - 1967</span>		
			<div v-if="detailsTitle" class="push__top">
				<Details :id="detailsId" :title="detailsTitle" :message="detailsMessage"/>
			</div>
			<span class="error-message" v-if="validate.$error">{{errorMessage}}</span>
			<span class="error-message" v-if="validate.day.maxValue == false && validate.$error || validate.day.minValue == false && validate.$error">Day field must be within 1 - 31</span>
			<span class="error-message" v-if="validate.month.maxValue == false && validate.$error || validate.month.minValue == false && validate.$error">Month field must be within 1 - 12</span>
			<span class="error-message" v-if="validate.year.maxValue == false && validate.$error || validate.year.minValue == false &&validate.$error">Year field must be within 1900 - {{currentYear}}</span>
			<div class="date" id="date-ex-1">
				<slot></slot>
			</div>
		</fieldset>   
	</div>
</template>

<script>
export default {
	name: 'Fieldset',
	props: {
		id: String,
		errorMessage: String,
		detailsTitle: String,
		detailsMessage: String,
		validate: {
			type: Object,
			required: false
		},
	},
  computed: {
    detailsId() {
      return `${this.id}-details`;
    },
	},
	data() {
		return {
			hintId : this.id + '-hint',
			currentYear : new Date().getFullYear()
		}
	},
	methods: {
		submit() {
			this.$emit("submit");
		}
	}
}
</script>